import { Layout } from "antd"
import { useContext } from "react"
import { ThemeContext } from "../Context/ThemeContext"
const { Footer } = Layout
const LayoutFooter = () => {
    const [theme] = useContext(ThemeContext)
    const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''
    return (
        <Footer className={changeNameClass}
            style={{
                textAlign: 'center'
            }}
            >
            <h3>
                Super Bootcamp ©2022 Created by Hadyan
            </h3>
        </Footer>
    )
}

export default LayoutFooter